import React, { useContext } from 'react'
import styled from '@emotion/styled'
import { Checkbox } from 'antd'
import PermissionsItemHeader from 'views/UserManagement/Permissions/PermissionsItem/PermissionsItemHeader'
import { PermissionsContext } from 'views/UserManagement/Permissions/index'

const PermissionsSelection = styled.div({
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr)',
  alignItems: 'start',
  gridGap: 20,
  padding: '30px 30px 0 30px'
})

const PermissionsItem = props => {
  const { project, onPermissionsChange, projectHidden, ...rest } = props
  const { permissionsOptions, isAccountAdmin } = useContext(PermissionsContext)
  const projectId = project.id
  const inProject = project.in_project
  const isProjectAdmin = project.project_admin
  const projectsPermissions = project.permissions

  const onPermission = event => onPermissionsChange(projectId, event)

  return (
    <div style={{ padding: 10, marginBottom: 10 }}>
      <PermissionsItemHeader
        id={projectId}
        name={project.name}
        inProject={inProject}
        isProjectAdmin={isProjectAdmin}
        {...rest}
      />
      <PermissionsSelection>
        <Checkbox
          onChange={onPermission}
          name={permissionsOptions[0].name}
          checked={projectsPermissions.includes(permissionsOptions[0].name) || isProjectAdmin || isAccountAdmin}
          disabled={isAccountAdmin || !inProject || isProjectAdmin}
        >
          {permissionsOptions[0].label}
        </Checkbox>
        <Checkbox
          onChange={onPermission}
          name={permissionsOptions[1].name}
          checked={projectsPermissions.includes(permissionsOptions[1].name) || isProjectAdmin || isAccountAdmin}
          disabled={isAccountAdmin || !inProject || isProjectAdmin}
        >
          {permissionsOptions[1].label}
        </Checkbox>
        <Checkbox
          onChange={onPermission}
          name={permissionsOptions[2].name}
          checked={projectsPermissions.includes(permissionsOptions[2].name) || isProjectAdmin || isAccountAdmin}
          disabled={isAccountAdmin || !inProject || isProjectAdmin}
        >
          {permissionsOptions[2].label}
        </Checkbox>
        <Checkbox
          onChange={onPermission}
          name={permissionsOptions[3].name}
          checked={projectsPermissions.includes(permissionsOptions[3].name) || isProjectAdmin || isAccountAdmin}
          disabled={isAccountAdmin || !inProject || isProjectAdmin}
        >
          {permissionsOptions[3].label}
        </Checkbox>
      </PermissionsSelection>
    </div>
  )
}

export default PermissionsItem
